import Vue from 'vue'

Vue.filter('dateyeartime', str => {
  return dayjs(str).format('DD.MM.YYYY H:mm')
})

Vue.filter('datetime', str => {
  return dayjs(str).format('DD.MM. H:mm')
})

Vue.filter('time', str => {
  return dayjs(str).format('H:mm')
})

Vue.filter('date', str => {
  return dayjs(str).format('DD.MM.')
})

Vue.filter('datename', str => {
  return dayjs(str).format('ddd')
})
